<template>
    <b-navbar toggleable="lg">
        <nav-logo class="pr-4 mr-auto"></nav-logo>

        <global-search v-if="search && !breakpointUp('lg')" class="mb-0 mr-3" :api-url="search"></global-search>

        <button-layout
            :label="trans('generic.menu')"
            icon="bars"
            class="d-lg-none"
            hide-label="xs"
            @click="visible = !visible"
        ></button-layout>

        <b-collapse id="nav-collapse" v-model="visible" is-nav class="align-items-lg-center">

            <slot></slot>

            <div class="d-flex mt-auto mt-lg-0 ml-lg-auto flex-column flex-lg-row align-items-lg-center">

                <global-search v-if="search && breakpointUp('lg')" class="mb-0 mr-3" :api-url="search"></global-search>

                <slot name="nav-end" :user-name="userName">
                    <div class="nav-item nav-label d-inline-flex align-items-center">{{ userName }}</div>
                </slot>

                <link-layout
                    v-if="impersonating"
                    class="nav-item nav-link pr-0"
                    variant="secondary"
                    :label="trans('auth.stop-impersonating')"
                    @click="stopImpersonating"
                ></link-layout>
                <link-layout
                    v-else
                    class="nav-item nav-link pr-0"
                    variant="secondary"
                    :label="trans('auth.logout')"
                    @click="logout"
                ></link-layout>

                <link-layout
v-b-toggle.nav-collapse
                    class="nav-item nav-link d-lg-none"
                    variant="secondary"
                    :label="trans('generic.close-menu')"
                ></link-layout>

            </div>
        </b-collapse>

        <div v-if="visible" class="nav-backdrop" @click="visible = false"></div>
    </b-navbar>
</template>

<script>
import ButtonLayout from "@/shared/buttons/ButtonLayout.vue"
import GlobalSearch from "@/shared/GlobalSearch.vue"
import LinkLayout from "@/shared/LinkLayout.vue"
import NavItem from "@/shared/NavItem.vue"
import NavLogo from "@/shared/NavLogo.vue"

import Breakpoints from "@/mixins/Breakpoints"

export default {
    components: {
        ButtonLayout,
        GlobalSearch,
        LinkLayout,
        NavItem,
        NavLogo,
    },
    mixins: [Breakpoints],
    props: {
        search: String,
    },
    data: () => ({
        visible: false,
    }),
    computed: {
        userName() {
            return this.$page.props.auth.user.name
        },
        impersonating() {
            return this.$page.props.auth.impersonating
        },
    },
    methods: {
        logout() {
            axios.post(this.route('logout'))
                .then(() => window.location = '/')
        },
        stopImpersonating() {
            this.$inertia.post(this.route('auth.stop-impersonating'))
        },
    },
}
</script>

<style scoped>
    .nav-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
    }
</style>
